import { featuresItems } from '@/mocks/homeData';

export default function FeaturesSection() {
  return (
    <section id="features" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-5xl mx-auto">
          <div className="text-center mb-10 md:mb-12">
            <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950">
              平台优势
            </h2>
            <p className="mt-3 text-sm md:text-base text-foreground-600">
              为什么数百万吃瓜群众选择每日爆料？
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
            {featuresItems.map((item) => (
              <div
                key={item.id}
                className="text-center p-6 md:p-8 bg-background-100 rounded-lg border border-background-200/70 hover:border-primary-200 transition-all duration-200 group"
              >
                <div className="w-14 h-14 md:w-16 md:h-16 mx-auto flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors">
                  <i className={`${item.icon} text-2xl`}></i>
                </div>
                <h3 className="mt-5 text-base md:text-lg font-semibold text-foreground-950">
                  {item.title}
                </h3>
                <p className="mt-3 text-sm text-foreground-600 leading-relaxed">
                  {item.desc}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}